'use client';

import { AddressStep } from './steps/AddressStep';
import { ContactInfoStep } from './steps/ContactInfoStep';
import { SystemIssuesStep } from './steps/SystemIssuesStep';
import { PictureStep } from './steps/PictureStep';
import { SystemAgeStep } from './steps/SystemAgeStep';
import { MessageStep } from './steps/MessageStep';
import { UrgencyStep } from './steps/UrgencyStep';
import { BuyingDecisionStep } from './steps/BuyingDecisionStep';
import ReplaceInPersonFormController from './ReplaceInPersonFormController';
import { Suspense } from 'react';
import { HeatSyncHandler } from '../HeatSyncHandler';

export interface ReplaceInPersonFormProps {
	testId?: string;
}

const ReplaceInPersonForm = (props: ReplaceInPersonFormProps) => {
	const { testId = 'ReplaceInPersonForm' } = props;

	return (
		<div data-testid={testId} className="flex grow flex-col">
			<Suspense>
				<ReplaceInPersonFormController>
					<HeatSyncHandler />
					<div className="hvac-container relative">
						{/* If you add a step remember to add the step component here. Order does not matter. */}
						<UrgencyStep />
						<AddressStep />
						<ContactInfoStep />
						<SystemIssuesStep />
						<PictureStep />
						<BuyingDecisionStep />
						<MessageStep />
						<SystemAgeStep />
					</div>
				</ReplaceInPersonFormController>
			</Suspense>
		</div>
	);
};

export default ReplaceInPersonForm;
